import React, { useState } from "react";
import "../../styles/CardNuoto.css";
import { useNavigate } from "react-router-dom";
import { motion } from 'framer-motion';

interface CardHomeProps {
    coloreSettore: string
    image: string;
    title: string;
    indirizzo: string;
}

function CardHome({ image, title, indirizzo, coloreSettore }: CardHomeProps) {
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };


    return (
        <div
            style={{
                position: "relative",
                margin: "15px",
                textAlign: "center",
                transition: "transform 0.3s" // Aggiunta di una transizione per un effetto più fluido
            }}
            onClick={() => navigate(`${indirizzo}`)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} >
            <img
                src={image}
                className="img-thumbnail"
                alt="..."
                style={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "300px",
                    objectFit: "cover",

                }}
            />
            <div
                style={{
                    position: "absolute",
                    top: "85%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: isHovered ? "white" : "#032041",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    width: "65%",
                    textAlign: "center",
                    cursor: "pointer",
                    backgroundColor: isHovered ? coloreSettore : "white",
                    borderRadius: "1em",
                    zIndex: 1
                }}
            >
                {title}
            </div>
            </motion.div>
        </div>
    );
}

export default CardHome;
